export default __webpack_public_path__ + "static/media/calendar.7af7d61c.svg";